import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import { AvGroup, AvField, AvForm } from "availity-reactstrap-validation";

import {
  Container,
  Content,
  Background,
  AnimationContainer,
  BackLogin,
  Text,
} from "./styles.js";

import logo from "../../../assets/logo.png";
import api from "../../../services/api";


export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const emailRef = useRef(null);
  const history = useHistory();


  const handleSubmit = async (data) => {
    setLoading(true);

    await api
      .get(`session/forgot-password?email=${emailRef.current.value}`)
      .then((res) => {
        history.push("/confirmation-forgot-password");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img
            style={{ height: 180 }}
            src={logo}
            alt="Infarma Sistemas"
          />
          <AvForm ref={formRef} onSubmit={handleSubmit}>
            <Text>Esqueci a senha</Text>
            <AvGroup>
              <AvField
                name="email"
                innerRef={emailRef}
                type="email"
                placeholder="Email"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Digite seu email.",
                  },
                  email: {
                    value: true,
                    errorMessage: "Digite um email válido.",
                  },
                }}
              />
            </AvGroup>
            <button type="submit" disabled={loading}>
              {loading ? "Aguarde..." : "Redefinir senha"}
            </button>
            <BackLogin>
              ou <a href="/login">Fazer login</a>
            </BackLogin>
          </AvForm>
        </AnimationContainer>
      </Content>
      <Background />
    </Container>
  );
}
